import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toFarsiNumber } from "../../cudtom-hooks/en-to-persian";
import {
  updatePending,
  callApiAgain,
  showPopUp,
} from "../common-states/commonStatesSlice";

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }
  return config;
});
export const getNomads = createAsyncThunk(
  "applicant/getNomads",
  async (data) => {
    const { searchParam, pageNum, dispatch } = data;
    dispatch(updatePending(true));
    let bodyArray = [];
    await axios
      .get(
        `https://api.khedmatashayer-kj.ir/v1/nomad/${pageNum}?${searchParam}`,
      )
      .then((response) => {
        console.log(response.data);
        const newArray = response.data
          ? response.data.map((item) => {
              return {
                nomad_id: item?.nomad_id,
                name: item?.name,
                national_code: item?.national_code,
              };
            })
          : [];
        localStorage.setItem("nomads", JSON.stringify(newArray)); // to have them for sending new request post api call.
        let array = [];
        response.data &&
          response.data.forEach((item) => {
            array = [
              ...array,
              [
                <i
                  className="fa fa-trash cursor-pointer text-base text-red-500"
                  onClick={() =>
                    dispatch(deleteNomad({ id: item.nomad_id, dispatch }))
                  }
                ></i>,
                <i
                  className="fa fa-edit cursor-pointer text-base text-lime-500"
                  onClick={() =>
                    dispatch(setNomadInfo({ obj: item, type: "showEditForm" }))
                  }
                ></i>,

                <i
                  className="fa fa-file-text-o cursor-pointer text-base text-gray-700"
                  onClick={() =>
                    dispatch(setNomadInfo({ obj: item, type: "showHistory" }))
                  }
                ></i>,
                <i
                  className="fa fa-file-text-o cursor-pointer text-base text-gray-700"
                  onClick={() =>
                    dispatch(setNomadInfo({ obj: item, type: "showInsurance" }))
                  }
                ></i>,

                toFarsiNumber(item.livestock_count),
                toFarsiNumber(item.population),
                toFarsiNumber(item.region),
                item.city,
                toFarsiNumber(item.mobiles[0].mobile),
                toFarsiNumber(item.national_code),
                item.name,
              ],
            ];
          });
        bodyArray = array;
        dispatch(updatePending(false));
      })
      .catch(() => {
        alert("خطا در برقراری ارتباط با سرور");
      });
    return bodyArray;
  },
);

export const addOrEditNomad = createAsyncThunk(
  "applicant/addOrEditNomad",
  async (allData, { rejectWithValue }) => {
    const { data, commonData, nomadId, dispatch, registerBtnType } = allData;

    try {
      let response;

      if (registerBtnType === "ثبت") {
        response = await axios.post(
          "https://api.khedmatashayer-kj.ir/v1/nomad",
          data,
        );

        dispatch(callApiAgain(true));
        dispatch(showPopUp({ type: "showForm", value: false }));
      } else {
        response = await axios.put(
          `https://api.khedmatashayer-kj.ir/v1/nomad/${nomadId}`,
          commonData,
        );

        dispatch(callApiAgain(true));
        dispatch(showPopUp({ type: "showEditForm", value: false }));
      }

      alert(response.data.message);
      return response.data;
    } catch (error) {
      alert(
        error.response?.data?.message || error.message || "خطایی رخ داده است.",
      );

      return rejectWithValue(error.response?.data);
    }
  },
);

export const deleteNomad = createAsyncThunk(
  "applicant/deleteNomad",
  async (data) => {
    const { id, dispatch } = data;
    let r = window.confirm("آیا برای حذف این مشترک اطمینان دارید؟");
    if (r === true) {
      axios
        .delete(`https://api.khedmatashayer-kj.ir/v1/nomad/${id}`)
        .then((res) => {
          console.log(res.data);
          dispatch(callApiAgain(true));
        })
        .then(() => {
          alert("مشترک موردنظر با موفقیت حذف شد!");
        })
        .catch(() => {
          alert("خطا در برقراری ارتباط با سرور");
        });
    }
  },
);

const applicantSlice = createSlice({
  name: "applicant",
  initialState: {
    bodyArray: [],
    selectedNomad: { obj: null, type: "" },
    inputsState: null,
    selectsState: null,
  },
  reducers: {
    setNomadInfo: (state, action) => {
      state.selectedNomad = action.payload;
    },
    setInputs: (state, action) => {
      state.inputsState = action.payload;
    },
    setSelects: (state, action) => {
      state.selectsState = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(getNomads.fulfilled, (state, action) => {
      state.bodyArray = action.payload;
    });
  },
});

export const { setNomadInfo, setInputs, setSelects } = applicantSlice.actions;
export const selectApplicantBodyArray = (state) => state.applicant.bodyArray;
export const selectSelectedNomad = (state) => state.applicant.selectedNomad;
export const selectInputsState = (state) => state.applicant.inputsState;
export const selectSelectsState = (state) => state.applicant.selectsState;

export default applicantSlice.reducer;
